module.exports = __webpack_public_path__ + "img/DROP-3-820x1024.c8a136fc.png";